<template>
    <div>
        <div v-if="loading" class="text-center" style="padding: 40px 0;">
            <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
        </div>
        <div v-else class="card w-100 margin-botton-20">
            <div class="card-body event-card-bg">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-8">
                        <div class="mb-3">
                            <div class="form-check form-check-inline" v-for="cat in ['Sun', 'Moon', 'Twilights', 'Planets', 'Season']" :key="cat">
                                <input class="form-check-input" type="checkbox" :id="'jcat-' + cat" :value="cat" v-model="journalCategoryFilter">
                                <label class="form-check-label" :for="'jcat-' + cat">{{ cat }}</label>
                            </div>
                        </div>
                        <div>
                            <template v-for="(row, idx) in journalFiltered">
                                <div v-if="row.is_now" :key="'now-' + idx" class="d-flex align-items-center my-2">
                                    <div class="flex-grow-1" style="border-top: 1px solid #198754;"></div>
                                    <span class="mx-2 text-success fw-semibold" style="font-size: 0.85em; letter-spacing: 0.05em;">Now: {{ journalNowTime }}</span>
                                    <div class="flex-grow-1" style="border-top: 1px solid #198754;"></div>
                                </div>
                                <div v-else :key="idx" class="d-flex align-items-baseline py-1" style="border-bottom: 1px solid rgba(0,0,0,0.06);">
                                    <span style="width: 3rem; text-align: center; flex-shrink: 0; white-space: nowrap;">
                                        <img v-if="row.category === 'Twilights'" :src="journalTwilightIcon(row)" style="height: 1.375rem; vertical-align: middle;" />
                                        <span v-else style="font-size: 1.375rem;">{{ row.symbol }}</span>
                                    </span>
                                    <span class="ms-3" style="font-size: 0.95em; text-align: left;">{{ row.line }}</span>
                                </div>
                            </template>
                        </div>
                        <p v-if="!journalEvents.length" class="text-center text-muted mt-3 mb-0">No events found.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import astroTabMixin from '@/mixins/astroTab'
import astra from '@/api/astra'

export default {
    name: 'TabJournal',
    mixins: [astroTabMixin],
    props: {
        active: { type: Boolean, default: false },
    },
    data() {
        return {
            loading: true,
            journalEvents: [],
            journalCategoryFilter: ['Sun', 'Moon', 'Twilights', 'Planets', 'Season'],
            journalNowTime: '',
        }
    },
    computed: {
        journalFiltered() {
            return this.journalEvents.filter(row =>
                row.category === '' || this.journalCategoryFilter.includes(row.category)
            )
        },
    },
    watch: {
        active(val) { if (val) this.load() },
        city()      { if (this.active) this.load() },
        date()      { if (this.active) this.load() },
    },
    mounted() {
        if (this.active) this.load()
    },
    methods: {
        journalTwilightIcon(row) {
            const line = (row.line || '').toLowerCase()
            if (line.includes('civil'))        return 'images/twilight/civil.png'
            if (line.includes('nautical'))     return 'images/twilight/nautical.png'
            if (line.includes('astronomical')) return 'images/twilight/astronomical.png'
            if (line.includes('night'))        return 'images/twilight/night.png'
            return 'images/twilight/day.png'
        },
        async load() {
            if (!this.latitude || !this.longitude || !this.timezone) return
            if (this.apiLocked) return
            this.loading = true
            this.journalEvents = []
            await Promise.allSettled([
                astra.fetchJournal({ ...this.loc, date1: this.dailyRange.date1 })
                    .then(r => {
                        this.journalEvents = r.data.events || []
                        const t = this.time || new Date()
                        this.journalNowTime = t.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }).toLowerCase()
                    })
                    .catch(() => {}),
            ])
            this.loading = false
        },
    },
}
</script>

<style scoped>
.margin-botton-20 { margin-bottom: 20px; }
</style>
